<template>
  <div class="box box-3" :class="{ 'ani-scale': !isMobileSize }" @click="$emit('openVideo', 3)">
    <img class="img-3" :src="img3" alt="" />
    <img class="add-icon" :src="addIcon" alt="" />
    <div class="title">{{ $t('keypalTwo.introduce.desc_4') }}</div>
    <div class="desc">{{ $t('keypalTwo.introduce.desc_11') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isMobileSize']),
    img3() {
      return require('../../assets/images/keypal-two/introduce-3.png');
    },
    addIcon() {
      return require('../../assets/images/keypal-two/add-1.png');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./card.scss');
.box-3 {
  width: 384px;
  height: 417px;

  .img-3 {
    // width: 352px;
    // height: 251px;
    width: 310px;
    height: 221px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 58px;
  }

  .desc {
    max-width: none;
  }
}

@media screen and (max-width: 1200px) {
  .box-3 {
    width: calc(384 / 1300 * 100vw);
    height: calc(417 / 1300 * 100vw);
    .img-3 {
      width: calc(310 / 1300 * 100vw);
      height: calc(221 / 1300 * 100vw);
    }
  }
}

@media screen and (max-width: 767px) {
  .box-3 {
    width: 276px;
    height: auto;
    .img-3 {
      width: 205px;
      height: 135px;
      position: absolute;
      left: 50%;
      top: 150px;
      transform: translateX(-50%);
    }
  }
}
</style>
